var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tree',{ref:"tree",attrs:{"data":_vm.data,"show-checkbox":"","node-key":"id","props":_vm.defaultProps}}),_c('br'),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.submit}},[_vm._v("提交")]),_c('el-button',{on:{"click":_vm.block}},[_vm._v("返回")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }